module.exports = __webpack_public_path__ + "2b12529f08a366fdf274a6aaa56ef7ff.png";